import { render, staticRenderFns } from "./FilesComponent.vue?vue&type=template&id=1f59681c&scoped=true&"
import script from "./FilesComponent.vue?vue&type=script&lang=js&"
export * from "./FilesComponent.vue?vue&type=script&lang=js&"
import style0 from "./FilesComponent.vue?vue&type=style&index=0&id=1f59681c&lang=scss&scoped=true&"
import style1 from "./FilesComponent.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f59681c",
  null
  
)

export default component.exports